import React from 'react';

import { SignupVerifierPageForm } from 'src/components/auth';
import { AuthSignupVerifierProvider } from 'src/providers/AuthSignupVerifierProvider';

export const SignUpVerifier: React.FC = () => {
  return (
    <AuthSignupVerifierProvider>
      <SignupVerifierPageForm />
    </AuthSignupVerifierProvider>
  );
};
